var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Carga y descarga")]),_c('p',[_vm._v("Aquí irá el módulo de carga y descarga.")])])
}]

export { render, staticRenderFns }